import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  cached: {},
  stores: getSavedState('stores') || [],
  store: getSavedState('store') || null,
  cashRegister: getSavedState('cash_register') || {},
  casherRegister: getSavedState('casher_register') || {},
}

export const getters = {
  stores: (state) => state.stores,
  store: (state) => state.store,
  cashRegister: (state) => state.cashRegister,
  casherRegister: (state) => state.casherRegister,
}

export const mutations = {
  CACHE_CAPTACION_POS(state, captacionPos) {
    state.cached = captacionPos
  },


  SET_STORES(state, stores) {
    state.stores = stores
    saveState('stores', stores)
  },

  SET_STORE(state, store) {
    state.store = store
    saveState('store', store)
  },
  
  SET_CASH_REGISTER(state, cashRegister) {
    state.cashRegister = cashRegister
    saveState('cash_register', cashRegister)
  },

  SET_CASHER_REGISTER(state, casherRegister) {
    state.casherRegister = casherRegister
    saveState('casher_register', casherRegister)
  },

}

export const actions = {
  init({ state, dispatch }) {},
  // Get Euro cash registers 
  fetchCashRegisterList(context, data) {
    return axios
      .get(`${serverUrl}/euro_captacion/get_casher_stores/`)
      .then((response) => {
        return response.data
      })
  },
  
  setStores(context, data){
    context.commit('SET_STORES', data)
  },

  setStore(context, data) {
    context.commit('SET_STORE', data)
  },

  setCashRegister(context, data){
    context.commit('SET_CASH_REGISTER', data)
  },

  setCasherRegister(context, data){
    context.commit('SET_CASHER_REGISTER', data)
  },
  
}


// ===
// Private helpers
// ===

// * GET key to current user
function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

// * Change key to current user
function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}